import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { AttentionPanel } from '@/features/Attention/AttentionPanel';
import { RaiseToTpoDialog } from '@/features/Attention/RaiseToTpoDialog';
import type { AttentionRow } from '@/lib/api/attention';

export const Route = createFileRoute('/trainer/batches/$batchId/attention')({
  component: AttentionTab,
});

function AttentionTab() {
  const { batchId } = Route.useParams();
  // Held here rather than inside the queue so the dialog survives the queue
  // refetching after a resolve.
  const [raising, setRaising] = useState<AttentionRow | null>(null);

  return (
    <>
      <AttentionPanel batchId={batchId} onRaise={setRaising} />
      <RaiseToTpoDialog batchId={batchId} row={raising} onClose={() => setRaising(null)} />
    </>
  );
}
